<template>
  <div class="wrapper">
    <div class="back">
      <v-btn icon small @click="goBack()">
        <v-icon class="secondary-color text--darken-1">arrow_back</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </div>
    <div class="login-card">
      <div class="login-card-header">
        <img
          :src="require(`@/assets/logos/usecargoazul.png`)"
          alt="pickndrive"
          style="width: 240px; margin-bottom: 12%; margin-top: 5%;"
        />
      </div>
      <form @submit.prevent="forgotPassword">
        <div class="form-group text-center">
          <label class="secondary-color" for="email-input">E-mail</label>
          <input
            type="email"
            class="secondary-color form-control"
            v-model="email"
            id="email-input"
            aria-describedby="emailHelp"
            placeholder="seuemail@host.com.br"
          />
          <small id="emailHelp" class="secondary-color form-text"
            >Assim que solicitar você receberá um email com instruções para
            realizar o procedimento.</small
          >
        </div>
        <button type="submit" class="btn white--text btn-block mt-5">
          SOLICITAR
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import AuthController from '../../controllers/AuthController.js';
import theming from '../../mixins/theming';

export default {
  mixins: [theming],
  data() {
    return {
      email: null,
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
  },

  methods: {
    goBack() {
      this.$router.push('/');
    },
    forgotPassword() {
      this.authController
        .forgotPassword(this.email)
        .then(res => {
          let message = res.body.message;
          let msgType = 'success';

          if (res.status == 204) {
            message =
              'Não há cadastro com esse e-mail. Verifique com responsável se já possui cadastro.';
            msgType = 'warning';
          }

          this.$message({
            type: msgType,
            message,
          });
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: JSON.parse(err.bodyText).message,
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.secondary-color {
  color: var(--secondary-color) !important;
}

.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  //background: url('../../assets/background-desktop.png');
  background-color: white;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
}

.wrapper .login-card {
  border-radius: 3px;
  padding: 15px 25px;
  // height: 100px;
  width: 350px;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.login-card label {
  color: black;
  font-weight: bold;
}

.login-card .change-visibility-span:hover {
  cursor: pointer;
}

.login-card .login-card-header {
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
}

.forgot-password {
  margin: 20px 0px;
}

.btn {
  background: var(--secondary-color) !important;
  font-weight: bold;
}

.back {
  display: flex;
  position: absolute;
  top: 30px;
  left: 40px;
}

.form-control {
  border: 1px solid #016ea7;
  // color: var(--primary-color) !important;
}
</style>
